export class FormType {
  name: string;

  constructor(datas?) {
    Object.assign(this, datas);
  }
}
